import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';

export type TEmailEventRow = {
	id: number;
	value: string;
	information: string;
	createdAt: string;
	ipAddress: string | null;
	userAgent: string | null;
};

export const eventsTableStructure: TTableStructure<keyof TEmailEventRow>[] = [
	{
		name: 'Event',
		selector: 'value' as keyof TEmailEventRow,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['send', 'Send'],
			['bounce', 'Bounce'],
			['delivery', 'Delivery'],
			['open', 'Open'],
			['click', 'Click'],
			['unsubscribe', 'Unsubscribe'],
		],
		colors: [
			['send', 'info.light'],
			['bounce', 'error.light'],
			['delivery', 'success.light'],
			['open', 'info.light'],
			['click', 'warning.light'],
			['unsubscribe', 'secondary.light'],
		],
	},
	{
		name: 'Created at',
		selector: 'createdAt' as keyof TEmailEventRow,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'IP',
		selector: 'ipAddress' as keyof TEmailEventRow,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'User agent',
		selector: 'userAgent' as keyof TEmailEventRow,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Information',
		selector: 'information' as keyof TEmailEventRow,
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Comments',
		selector: 'comments' as keyof TEmailEventRow,
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
];
